import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Address, Billing, Contact, Copy, Customer, CustomerInfo, EmailBox, Filter, Payment, Phone, Shipping, ShippingID, ShippingMethod, Users } from '../../Svg';
import NestedUserHeader from '../../component/reusable/NestedUserHeader';
import { useDispatch, useSelector } from 'react-redux';
import { useParams,useLocation } from 'react-router-dom';
import { handleCopy } from '../../utils/fomateDate';
import {
  MenuItem,
  Menu,
  Button,
  Paper,
  Typography,
  Box,
  Divider, Grid

} from "@mui/material";
import { ArrowDropDown } from '@mui/icons-material';

import ScheduleList from '../../component/scheduleComps/scheduleList/ScheduleList';
import { scheduleDetailsThunk, setschedulerefresh } from '../../redux/schedulecartslice';
import api from '../../utils/api';
import { toast } from 'react-toastify';




const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#512DA8',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));


const status = ["NEW", "PENDING", "APPROVED"]

const ScheduleEnqDetails = (setStatus,) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { id } = useParams()
  const { loading, refresh, orderDetails } = useSelector((state) => state.schedule);

  const dispatch = useDispatch()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (status) => {
    if (status) {
      changeStatus(status)
    }
    setAnchorEl(null);
  };


  useEffect(() => {
    dispatch(scheduleDetailsThunk(id))
  }, [refresh])

  const changeStatus = async (status) => {
    const datas = {
      id: id,
      status: status
    }
    try {
      const { data } = await api.updateScheduleStatus(datas)
      if (data) {
        toast.success('status updated succesfully')
        dispatch(setschedulerefresh())
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || 'something went wrong')
    } finally {
    }
  }

  const location = useLocation()
  const path = location.pathname.split("/")[2]

  console.log(path,'path')


  return (
    <>
      <NestedUserHeader
        index="Scheduling details"
        root="Dashboard"
        buttonText={'Quote Now'}
      />


      <div style={{ borderLeft: "1px solid #DCDEE3", padding: "10px 20px" }}>
        <div style={{ display: 'flex', justifyContent: "space-between", padding: '20px 0px' }}>
          <div style={{ display: 'flex' }}>
            <Typography
              sx={{
                color: 'rgba(29, 31, 44, 1)',
                fontSize: '20px',
                fontWeight: '600',
                fontFamily: `'Public Sans', sans-serif`,
              }}>
              ID # {orderDetails?._id}
            </Typography>
            <Typography style={{
              marginLeft: '10px', padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600",
              color: orderDetails?.status === "NEW" ? "#4A4C56" : orderDetails?.status === "PENDING" ? "#E9BD21" : "#1A9882",
              background: orderDetails?.status === "NEW" ? "#4A4C561A" : orderDetails?.status === "PENDING" ? "#FFF0EA" : "#E9FAF7",
            }}>
              {orderDetails?.status}
            </Typography>
          </div>
          <div>
            <ActionButton
              onClick={handleClick}
              sx={{
                color: '#667085',
                border: '1px solid #E0E2E7',
                background: '#fff',
                borderRadius: '8px',
              }}
            >
              {orderDetails?.status}
              <ArrowDropDown />
            </ActionButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={() => handleClose('')}
              MenuListProps={{
                'aria-labelledby': 'status-button',
              }}
            >
              {status?.map((i) => (

                <MenuItem onClick={() => handleClose(i)}
                  sx={{
                    borderBottom: '1px solid #E6E1E5',
                    fontSize: '14px',
                    color: '#667085',
                  }}>{i}</MenuItem>
              ))
              }
            </Menu>
          </div>
        </div>

        {loading ? <div>Please wait...</div> :
          <Box maxWidth="lg">
            <Grid container spacing={3} >
              <Grid item xs={12} md={6}>
                <Paper sx={{ height: '100%', boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                  <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                    <CustomerInfo />
                    <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                      Customer Info
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Customer />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Customer:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {orderDetails?.user?.fullName}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <EmailBox />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Email:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {orderDetails?.user?.email}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <div onClick={() => handleCopy(orderDetails?.user?.email)}>
                        <Copy />
                      </div>
                    </Box>
                  </Box>
                  <Box sx={{ p: '24px 24px 24px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Phone />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Phone Number:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {orderDetails?.user?.phone}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <div onClick={() => handleCopy(orderDetails?.user?.phone)}>
                        <Copy />
                      </div>
                    </Box>
                  </Box>
                  {/* <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Address />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Shipping Address:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                        {orderDetails?.address?.factoryUnits}<br />
                        {orderDetails?.address?.streetAddress}, {orderDetails?.address?.state} - {orderDetails?.address?.zipCode},{orderDetails?.address?.country}
                        </Typography>
                      </Box>
                    </Box>
                  </Box> */}
                </Paper>
              </Grid>


              <Grid item xs={12} md={6}>
                <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                  <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                    <Contact />
                    <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                      Enquiry Info
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Box sx={{ p: '24px 24px 24px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" flexDirection="column" gap='10px'>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Scheduled months/Period:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {orderDetails?.period}
                        </Typography>
                      </Box>

                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Schedule date:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {orderDetails?.scheduleDate}
                        </Typography>
                      </Box>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', marginBottom: '4px', }}>
                          Project remarks:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {orderDetails?.remarks}
                        </Typography>
                      </Box>

                    </Box>
                  </Box>
                </Paper>
              </Grid>


            </Grid>

            <ScheduleList
              products={orderDetails?.products}
              price={orderDetails?.priceBreakup}
              enqData={orderDetails?.createdAt}
              status={orderDetails?.status}
              changeStatus={changeStatus}
              id={orderDetails?._id}
              path={path}
            />



          </Box>
        }
      </div>
    </>
  );
};

export default ScheduleEnqDetails;
